module.exports={
	"Form": "TestInstanceCreateManifest",
	"Scope": "TestInstance-Create",
	"Descriptors":
	{
		"TestInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestInstance-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestInstance-Create-Identity",
				"Group": "TestInstance-Create-Identity"
			}
		},
		"TestInstanceDetails.IDTestPlan":
		{
			"Name": "Test Plan",
			"Hash": "TestInstance-Create-IDTestPlan",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "TestPlan",
				"SearchFields":
				[
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestInstance-Create-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDLab":
		{
			"Name": "Lab",
			"Hash": "TestInstance-Create-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"TestInstanceDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "TestInstance-Create-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"TestInstanceDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "TestInstance-Create-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "TestInstance-Create-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"TestInstanceDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "TestInstance-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "TestInstance-Create-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.EstimatedCompletionDate":
		{
			"Name": "Estimated Completion Date",
			"Hash": "TestInstance-Create-EstimatedCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.ActualCompletionDate":
		{
			"Name": "Actual Completion Date",
			"Hash": "TestInstance-Create-ActualCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.Status":
		{
			"Name": "Status",
			"Hash": "TestInstance-Create-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.StatusMessage":
		{
			"Name": "Status Message",
			"Hash": "TestInstance-Create-StatusMessage",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.SampleTestNumber":
		{
			"Name": "Sample Test Number",
			"Hash": "TestInstance-Create-SampleTestNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.TestResult":
		{
			"Name": "Test Result",
			"Hash": "TestInstance-Create-TestResult",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestInstance-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestInstance-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestInstance-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestInstance-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
